'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ICON_SIZES = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _gridConstants = require('../../utils/grid/gridConstants');

var _gridSizeSelector = require('../../utils/grid/gridSizeSelector');

var _logger = require('../../utils/logger');

var _logger2 = _interopRequireDefault(_logger);

var _large = require('./large');

var _large2 = _interopRequireDefault(_large);

var _small = require('./small');

var _small2 = _interopRequireDefault(_small);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZES = exports.ICON_SIZES = {
    SMALL: 'SMALL',
    LARGE: 'LARGE'
};

var iconSelector = (0, _reselect.createSelector)(_gridSizeSelector.getGridSizeName, function (state, props) {
    return props.size;
}, function (sizeName, overideSize) {
    if (overideSize) return { iconSize: overideSize };

    var iconSize = sizeName === _gridConstants.GRID.SMALL.name ? ICON_SIZES.SMALL : ICON_SIZES.LARGE;

    return { iconSize: iconSize };
});

var Icon = function Icon(_ref) {
    var name = _ref.name,
        iconSize = _ref.iconSize;

    var SmallIcon = _small2.default[name];
    var LargeIcon = _large2.default[name];
    var RenderIcon = SmallIcon && iconSize === ICON_SIZES.SMALL ? SmallIcon : LargeIcon;

    if (!RenderIcon) {
        _logger2.default.warn('Icon not found (name: ' + name + ', iconSize: ' + iconSize + ')');
        return null;
    }

    return _react2.default.createElement(RenderIcon, null);
};

Icon.propTypes = {
    name: _propTypes2.default.string,
    iconSize: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(iconSelector)(Icon);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/Icon.js
// module id = 11
// module chunks = 0